function initFaq() {
	const faqQuestions = document.querySelectorAll('.faq-question');

	faqQuestions.forEach(function (question) {
		question.addEventListener('click', function (e) {
			e.preventDefault();

			const faqItem = this.closest('.faq-item');
			const content = faqItem.querySelector('.faq-answer');

			// Використовуємо jQuery тільки для slideToggle
			jQuery(content).slideToggle(300);
			faqItem.classList.toggle('is-active');
		});
	});
}

initFaq();
function initHeaderMenu() {
	const headerMenuLinks = document.querySelectorAll('.header-menu-link--dropdown');
	const allSubmenus = document.querySelectorAll('.header-submenu');

	headerMenuLinks.forEach(link => {
		const menuItem = link.closest('.header-menu-item');
		const currentSubmenu = menuItem.querySelector('.header-submenu');
		link.addEventListener('click', (e) => {
			e.preventDefault();


			// Закриваємо всі інші підменю
			allSubmenus.forEach(submenu => {
				if (submenu !== currentSubmenu) {
					jQuery(submenu).slideUp(300);
					submenu.classList.remove('active');
				}
			});

			// Перемикаємо поточне підменю
			if (currentSubmenu) {
				jQuery(currentSubmenu).slideToggle(300);
				menuItem.classList.toggle('is-active');
			}
		});
	});

	// Закриваємо підменю при кліку поза ним
	document.addEventListener('click', (e) => {
		if (!e.target.closest('.header-menu-item')) {
			const allSubmenus = document.querySelectorAll('.header-submenu');
			allSubmenus.forEach(submenu => {
				jQuery(submenu).slideUp(300);
				submenu.classList.remove('active');
			});
			document.querySelectorAll('.header-menu-item').forEach(item => {
				item.classList.remove('is-active');
			});
		}
	});
}

// function initHeaderMenuMobile() {
// 	const headerBurger = document.querySelector('.header-burger');
// 	const headerMenuClose = document.querySelector('.header-menu-close');
// 	const headerMenu = document.querySelector('.header-menu');

// 	headerBurger.addEventListener('click', () => {
// 		headerMenu.classList.toggle('is-active');
// 	});

// 	headerMenuClose.addEventListener('click', () => {
// 		headerMenu.classList.remove('is-active');
// 	});
// }

initHeaderMenu();
// initHeaderMenuMobile();

// Глобальна змінна для екземпляра Swiper
let reviewsSwiperInstance = null;
let savedSwiperPosition = null;

function initreviewsSlider() {
	const reviewsSwiper = document.querySelector('.reviews-slider');
	const reviewsSwiperItems = document.querySelectorAll('.reviews-item');
	const reviewsBtnPrev = document.querySelector('.reviews-nav .btn-arrow--prev');
	const reviewsBtnNext = document.querySelector('.reviews-nav .btn-arrow--next');

	if (!reviewsSwiper) return;

	reviewsSwiperInstance = new Swiper(reviewsSwiper, {
		slidesPerView: 'auto',
		spaceBetween: 9,
		loop: true,
		centeredSlides: true,
		navigation: {
			prevEl: reviewsBtnPrev,
			nextEl: reviewsBtnNext,
		},
		pagination: {
			el: '.reviews-nav .swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			768: {
				spaceBetween: 24,
				loop: false,
				centeredSlides: false,
			},
		},
	});

	reviewsSwiperItems.forEach(function (item) {
		item.addEventListener('click', function () {
			savedSwiperPosition = reviewsSwiperInstance.translate;
			reviewsSwiperInstance.disable();
		});
	});
}

// Ініціалізація Fancybox для галереї сертифікатів
function initreviewsGallery() {
	if (typeof Fancybox === 'undefined') return;

	Fancybox.bind("[data-fancybox='video']", {
		Toolbar: {
			display: {
				left: ["infobar"],
				middle: [],
				right: ["slideshow", "thumbs", "close"],
			},
		},
		Thumbs: {
			autoStart: true,
		},
		showClass: "f-fadeIn",
		hideClass: "f-fadeOut",
		fitToView: true,
		autoFocus: false,
		keyboard: {
			Escape: "close",
			Delete: "close",
			Backspace: "close",
			PageUp: "next",
			PageDown: "prev",
			ArrowRight: "next",
			ArrowLeft: "prev",
			ArrowUp: "prev",
			ArrowDown: "next",
			Space: "play",
		},
		on: {

			destroy: () => {
				setTimeout(() => {
					reviewsSwiperInstance.enable();
					reviewsSwiperInstance.setTranslate(savedSwiperPosition);
					reviewsSwiperInstance.updateActiveIndex();
				}, 50);
			}
		}
	});
}


const testimonials = document.querySelector('.testimonials');

// if (testimonialsSlider) {
// 	new Swiper(testimonialsSlider, {
// 		slidesPerView: 2,
// 		spaceBetween: 12,
// 		loop: true,
// 		navigation: {
// 			nextEl: testimonialsNav.querySelector('.btn-arrow--next'),
// 			prevEl: testimonialsNav.querySelector('.btn-arrow--prev'),
// 		},
// 		breakpoints: {
// 			525: {
// 				slidesPerView: 'auto',
// 				spaceBetween: 24,
// 			},
// 		},
// 	});
// }


if (testimonials) {
	const testimonialsSlider = testimonials.querySelector('.testimonials-slider');
	const testimonialsNav = testimonials.querySelector('.testimonials-nav');

	if (testimonialsSlider && testimonialsNav) {
		new Swiper(testimonialsSlider, {
			slidesPerView: 2,
			spaceBetween: 12,
			loop: true,
			navigation: {
				nextEl: testimonialsNav.querySelector('.btn-arrow--next'),
				prevEl: testimonialsNav.querySelector('.btn-arrow--prev'),
			},
			breakpoints: {
				525: {
					slidesPerView: 'auto',
					spaceBetween: 24,
				},
			},
		});
	}
}

// js code for video testimonials for product template extra01

(() => {
  const ROOT_SELECTOR = '[data-pvt-root]';
  const ROOT_BOUND_ATTR = 'data-pvt-bound';

  function initVideoTestimonials(root) {
    if (!root || root.getAttribute(ROOT_BOUND_ATTR) === 'true') return;
    root.setAttribute(ROOT_BOUND_ATTR, 'true');

    const modals = Array.from(root.querySelectorAll('.pvt-modal'));

    function moveRootModalsToBody() {
      modals.forEach((modal) => {
        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }
      });
    }

    function syncMuteButton(video, muteControl) {
      if (!video || !muteControl) return;
      muteControl.classList.toggle('is-muted', video.muted);
    }

    function playVideo(video, muteControl) {
      if (!video) return;

      try {
        video.pause();
        video.currentTime = 0;

        video.muted = false;
        video.removeAttribute('muted');

        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            video.muted = true;
            video.setAttribute('muted', 'muted');

            const mutedPlayPromise = video.play();
            if (mutedPlayPromise && typeof mutedPlayPromise.catch === 'function') {
              mutedPlayPromise.catch(() => {});
            }

            syncMuteButton(video, muteControl);
          });
        }
      } catch (_) {}
    }

    function openModal(modal) {
      if (!modal) return;

      modal.hidden = false;
      document.body.classList.add('pvt-modal-open');

      const video = modal.querySelector('[data-video]');
      const muteControl = modal.querySelector('[data-toggle-mute]');

      playVideo(video, muteControl);
      syncMuteButton(video, muteControl);
    }

    function closeModal(modal) {
      if (!modal) return;

      const video = modal.querySelector('[data-video]');
      const muteControl = modal.querySelector('[data-toggle-mute]');

      if (video) {
        video.pause();
        video.currentTime = 0;
        video.muted = false;
        video.removeAttribute('muted');
      }

      syncMuteButton(video, muteControl);

      modal.hidden = true;

      const anyOpenModal = document.querySelector('.pvt-modal:not([hidden])');
      if (!anyOpenModal) {
        document.body.classList.remove('pvt-modal-open');
      }
    }

    function closeAllRootModals() {
      modals.forEach((modal) => {
        if (!modal.hidden) {
          closeModal(modal);
        }
      });
    }

    moveRootModalsToBody();

    root.addEventListener('click', (event) => {
      const openBtn = event.target.closest('[data-open-video]');
      if (!openBtn || !root.contains(openBtn)) return;

      const targetId = openBtn.getAttribute('data-open-video');
      if (!targetId) return;

      const modal = document.getElementById(targetId);
      openModal(modal);
    });

    modals.forEach((modal) => {
      modal.addEventListener('click', (event) => {
        const closeBtn = event.target.closest('[data-close-video]');
        const muteBtn = event.target.closest('[data-toggle-mute]');

        if (closeBtn) {
          closeModal(modal);
          return;
        }

        if (muteBtn) {
          const video = modal.querySelector('[data-video]');
          if (!video) return;

          video.muted = !video.muted;

          if (video.muted) {
            video.setAttribute('muted', 'muted');
          } else {
            video.removeAttribute('muted');
          }

          syncMuteButton(video, muteBtn);

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeAllRootModals();
    });

    document.addEventListener('shopify:section:load', moveRootModalsToBody);
    document.addEventListener('shopify:section:reorder', moveRootModalsToBody);
    document.addEventListener('shopify:block:select', moveRootModalsToBody);
  }

  function bootVideoTestimonials() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initVideoTestimonials);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootVideoTestimonials);
  } else {
    bootVideoTestimonials();
  }

  document.addEventListener('shopify:section:load', bootVideoTestimonials);
})();

// js code for sticky ATC button for extra01 template

(() => {
  const STICKY_SELECTOR = '#StickyPurchaseBar';
  const LOOP_OPTION_SELECTOR = [
    '[data-loop-widget-selling-plan-group]',
    '[data-loop-widget-onetime-purchase-option]'
  ].join(',');

  function initStickyBar(stickyBar) {
    if (!stickyBar || stickyBar.dataset.bound === 'true') return;
    stickyBar.dataset.bound = 'true';

    const metaEl = stickyBar.querySelector('#StickyPurchaseMeta');
    const atcButton = stickyBar.querySelector('#StickyPurchaseBarAtc');
    const atcPrice = stickyBar.querySelector('.sticky-purchase-bar__atc-price');
    const dropdown = stickyBar.querySelector('#StickyPlanDropdown');
    const primaryButton = stickyBar.querySelector('#StickyPlanTrigger');
    const primaryLabel = primaryButton?.querySelector('.sticky-plan-option__label');
    const primarySub = primaryButton?.querySelector('.sticky-plan-option__sub');

    let currentSelection = {
      type: 'subscription',
      label: '',
      price: '',
      loopTarget: ''
    };

    let loopMap = new Map();

    applyColorVars();
    bindUI();
    bindLoopToStickyUpdates();
    waitForLoopWidget(buildStickyPlansFromLoop);

    function applyColorVars() {
      stickyBar.style.setProperty('--sticky-bg-color', stickyBar.dataset.bgColor || '#f7f2f2');
      stickyBar.style.setProperty('--sticky-text-color', stickyBar.dataset.textColor || '#66101a');
      stickyBar.style.setProperty('--sticky-outline-color', stickyBar.dataset.outlineColor || '#8e1a24');
      stickyBar.style.setProperty('--sticky-selector-bg', stickyBar.dataset.selectorBg || '#ffffff');
      stickyBar.style.setProperty('--sticky-button-bg', stickyBar.dataset.buttonBg || '#970012');
      stickyBar.style.setProperty('--sticky-button-text-color', stickyBar.dataset.buttonTextColor || '#ffffff');
    }

    function getLoopOptions() {
      return Array.from(document.querySelectorAll(LOOP_OPTION_SELECTOR));
    }

    function getLoopOptionData(optionEl) {
      if (!optionEl) return null;

      const labelNode = optionEl.querySelector('.loop-widget-purchase-option-label');
      const priceNode = optionEl.querySelector('.loop-widget-purchase-option-price');

      const label = labelNode ? labelNode.textContent.trim() : '';
      const price = priceNode ? priceNode.textContent.trim() : '';
      const type = optionEl.hasAttribute('data-loop-widget-onetime-purchase-option')
        ? 'onetime'
        : 'subscription';

      if (!label) return null;

      return {
        element: optionEl,
        type,
        label,
        price,
        loopTarget: label
      };
    }

    function rebuildLoopMap() {
      loopMap.clear();

      getLoopOptions().forEach((option) => {
        const data = getLoopOptionData(option);
        if (!data) return;
        loopMap.set(data.label.toLowerCase(), data);
      });
    }

    function getSelectedLoopOption() {
      const options = getLoopOptions();

      for (const option of options) {
        const selected =
          option.classList.contains('loop-widget-purchase-option-selected') ||
          option.getAttribute('aria-checked') === 'true';

        if (selected) {
          return getLoopOptionData(option);
        }
      }

      return options.length ? getLoopOptionData(options[0]) : null;
    }

    function updateStickyUI(selection) {
      if (!selection) return;

      currentSelection = {
        type: selection.type || 'subscription',
        label: selection.label || '',
        price: selection.price || '',
        loopTarget: selection.loopTarget || selection.label || ''
      };

      if (primaryLabel) primaryLabel.textContent = currentSelection.label;
      if (primarySub) primarySub.textContent = currentSelection.price;
      if (atcPrice) atcPrice.textContent = currentSelection.price;

      if (metaEl) {
        metaEl.textContent = `${currentSelection.label} · ${currentSelection.price}`;
      }

      dropdown?.querySelectorAll('[data-sticky-plan]').forEach((item) => {
        item.classList.toggle(
          'is-active',
          item.dataset.planLabel === currentSelection.label
        );
      });
    }

    function buildStickyPlansFromLoop() {
      if (!dropdown) return false;

      rebuildLoopMap();
      const plans = Array.from(loopMap.values());
      if (!plans.length) return false;

      const fragment = document.createDocumentFragment();

      plans.forEach((plan) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sticky-plan-dropdown__item';
        button.dataset.stickyPlan = '';
        button.dataset.planType = plan.type;
        button.dataset.planLabel = plan.label;
        button.dataset.planPrice = plan.price;
        button.dataset.loopTarget = plan.loopTarget;
        button.textContent = plan.label;
        fragment.appendChild(button);
      });

      dropdown.innerHTML = '';
      dropdown.appendChild(fragment);

      const selected = getSelectedLoopOption() || plans[0];
      updateStickyUI(selected);

      return true;
    }

    function toggleDropdown() {
      if (!dropdown || !primaryButton) return;
      dropdown.hidden = !dropdown.hidden;
      primaryButton.setAttribute('aria-expanded', dropdown.hidden ? 'false' : 'true');
    }

    function closeDropdown() {
      if (!dropdown || !primaryButton) return;
      dropdown.hidden = true;
      primaryButton.setAttribute('aria-expanded', 'false');
    }

    function findMainProductForm() {
      return (
        document.querySelector('product-form form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]')
      );
    }

    function syncVariantIdToMainForm(form) {
      if (!form) return null;

      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return form;

      const selectedVariantInput =
        document.querySelector('variant-selects [name="id"]') ||
        document.querySelector('variant-radios [name="id"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]');

      if (selectedVariantInput?.value) {
        variantInput.value = selectedVariantInput.value;
      }

      return form;
    }

    function syncLoopPlanSelection(targetText, updateAfter = false) {
      if (!targetText) return false;

      const plan = loopMap.get(targetText.trim().toLowerCase());
      if (!plan?.element) return false;

      plan.element.focus();
      plan.element.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );

      if (updateAfter) {
        window.setTimeout(() => {
          rebuildLoopMap();
          const selected = getSelectedLoopOption();
          if (selected) updateStickyUI(selected);
        }, 120);
      }

      return true;
    }

    function submitMainProductForm() {
      const form = syncVariantIdToMainForm(findMainProductForm());
      if (!form) return;

      const nativeAddButton =
        form.querySelector('[type="submit"]') ||
        form.querySelector('button[name="add"]');

      if (nativeAddButton) {
        nativeAddButton.click();
      } else if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    function handleStickyAddToCart() {
      const synced = syncLoopPlanSelection(currentSelection.loopTarget, true);

      window.setTimeout(() => {
        submitMainProductForm();
      }, synced ? 250 : 80);
    }

    function handleDropdownClick(event) {
      const item = event.target.closest('[data-sticky-plan]');
      if (!item) return;

      const selection = {
        type: item.dataset.planType,
        label: item.dataset.planLabel,
        price: item.dataset.planPrice,
        loopTarget: item.dataset.loopTarget
      };

      updateStickyUI(selection);
      closeDropdown();
      syncLoopPlanSelection(selection.loopTarget, true);
    }

    function bindUI() {
      primaryButton?.addEventListener('click', toggleDropdown);
      dropdown?.addEventListener('click', handleDropdownClick);
      atcButton?.addEventListener('click', handleStickyAddToCart);

      document.addEventListener('click', (event) => {
        if (!stickyBar.contains(event.target)) {
          closeDropdown();
        }
      });
    }

    function bindLoopToStickyUpdates() {
      document.addEventListener('click', (event) => {
        const loopOption = event.target.closest(LOOP_OPTION_SELECTOR);
        if (!loopOption) return;

        window.setTimeout(() => {
          rebuildLoopMap();
          const selected = getSelectedLoopOption();
          if (selected) updateStickyUI(selected);
        }, 120);
      });
    }

    function waitForLoopWidget(callback) {
      if (getLoopOptions().length) {
        callback();
        return;
      }

      const observer = new MutationObserver(() => {
        if (getLoopOptions().length) {
          observer.disconnect();
          callback();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      window.setTimeout(() => observer.disconnect(), 15000);
    }
  }

  function bootStickyAtcLoop() {
    document.querySelectorAll(STICKY_SELECTOR).forEach(initStickyBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootStickyAtcLoop);
  } else {
    bootStickyAtcLoop();
  }

  document.addEventListener('shopify:section:load', bootStickyAtcLoop);
})();

document.addEventListener('DOMContentLoaded', () => {
  const bundleContent = {
    cN7v: `
      <div class="benefits-section" data-benefit-group="group-1">
        <div class="gift-row">
          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$75</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/a6a7bf5209910400980d4f358caf81f0d2637d60_1.png?v=1775076239" alt="Vitatlity Capsules">
            </div>
            <p>Vitatlity Capsules</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$29</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/26b598fd27c184b19a47901e31c980ba00c27cec.png?v=1776165273" alt="Gua Sha">
            </div>
            <p>Gua Sha</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$16</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/9b24d684728acf0dad50995d9a930f3957b42cf5.png?v=1776165273" alt="Body Brush">
            </div>
            <p>Body Brush</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$25</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/b0f8054fcb092f787a6eedb467f55e1dc15c1a13.png?v=1776165272" alt="Reset Protocol">
            </div>
            <p>Reset Protocol</p>
          </div>
        </div>

        <div class="benefit-item"> 
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>    
          <p>MAXIMIUM SAVINGS: LOWEST PRICE</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>30 Day Money Back Guarantee</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>Free USA Shipping</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>3 bottles- 90 Day Supply</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span> 
          <p>Cancel or Pause Anytime</p>
        </div>
      </div>
    `,
    onBI: `
      <div class="benefits-section" data-benefit-group="group-1">
        <div class="gift-row">
          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$75</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/a6a7bf5209910400980d4f358caf81f0d2637d60_1.png?v=1775076239" alt="Vitatlity Capsules">
            </div>
            <p>Vitatlity Capsules</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$29</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/26b598fd27c184b19a47901e31c980ba00c27cec.png?v=1776165273" alt="Gua Sha">
            </div>
            <p>Gua Sha</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$16</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/9b24d684728acf0dad50995d9a930f3957b42cf5.png?v=1776165273" alt="Body Brush">
            </div>
            <p>Body Brush</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$25</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/b0f8054fcb092f787a6eedb467f55e1dc15c1a13.png?v=1776165272" alt="Reset Protocol">
            </div>
            <p>Reset Protocol</p>
          </div>
        </div>

        <div class="benefit-item"> 
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>    
          <p>MAXIMIUM SAVINGS: LOWEST PRICE</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>30 Day Money Back Guarantee</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>Free USA Shipping</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>3 bottles- 90 Day Supply</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span> 
          <p>Cancel or Pause Anytime</p>
        </div>
      </div>
    `,
    UMrQ: `
      <div class="benefits-section" data-benefit-group="group-1">
        <div class="gift-row">
          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$64.95</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/1_5.png?v=1776277766" alt="Shilajit">
            </div>
            <p>Shilajit</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$29</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/26b598fd27c184b19a47901e31c980ba00c27cec.png?v=1776165273" alt="Gua Sha">
            </div>
            <p>Gua Sha</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$16</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/9b24d684728acf0dad50995d9a930f3957b42cf5.png?v=1776165273" alt="Body Brush">
            </div>
            <p>Body Brush</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$25</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/b0f8054fcb092f787a6eedb467f55e1dc15c1a13.png?v=1776165272" alt="Reset Protocol">
            </div>
            <p>Reset Protocol</p>
          </div>
        </div>

        <!-- YOUR ORIGINAL BENEFITS -->
        <div class="benefit-item"> 
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>    
          <p>MAXIMIUM SAVINGS: LOWEST PRICE</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>30 Day Money Back Guarantee</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>Free USA Shipping</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>3 jars -90 day supply</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span> 
          <p>Cancel or Pause Anytime</p>
        </div>          
    </div>
    `,
    Tkdg: `
      <div class="benefits-section" data-benefit-group="group-1">

        <!-- GIFT ROW -->
        <div class="gift-row">

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$150</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/3_5.png?v=1776277767" alt="Advanced Cellular">
            </div>
            <p>Capsules + Shilajit</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$29</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/26b598fd27c184b19a47901e31c980ba00c27cec.png?v=1776165273" alt="Gua Sha">
            </div>
            <p>Gua Sha</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$16</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/9b24d684728acf0dad50995d9a930f3957b42cf5.png?v=1776165273" alt="Body Brush">
            </div>
            <p>Body Brush</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$25</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/b0f8054fcb092f787a6eedb467f55e1dc15c1a13.png?v=1776165272" alt="Reset Protocol">
            </div>
            <p>Reset Protocol</p>
          </div>
        </div>

        <!-- YOUR ORIGINAL BENEFITS -->
        <div class="benefit-item"> 
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>    
          <p>MAXIMIUM SAVINGS: LOWEST PRICE</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>30 Day Money Back Guarantee</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>Free USA Shipping</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>3 Bottles + 3 Jars- 90 Day Supply</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span> 
          <p>Cancel or Pause Anytime</p>
        </div>

      </div>
    `,
    d0ZM: `
      <div class="benefits-section" data-benefit-group="group-1">

        <!-- GIFT ROW -->
        <div class="gift-row">

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$140</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/4_3.png?v=1776277767" alt="Regular Cellular">
            </div>
            <p>Capsules + Shilajit</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$29</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/26b598fd27c184b19a47901e31c980ba00c27cec.png?v=1776165273" alt="Gua Sha">
            </div>
            <p>Gua Sha</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$16</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/9b24d684728acf0dad50995d9a930f3957b42cf5.png?v=1776165273" alt="Body Brush">
            </div>
            <p>Body Brush</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$25</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/b0f8054fcb092f787a6eedb467f55e1dc15c1a13.png?v=1776165272" alt="Reset Protocol">
            </div>
            <p>Reset Protocol</p>
          </div>
        </div>

        <!-- YOUR ORIGINAL BENEFITS -->
        <div class="benefit-item"> 
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>    
          <p>MAXIMIUM SAVINGS: LOWEST PRICE</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>30 Day Money Back Guarantee</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>Free USA Shipping</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>  
          <p>3 Bottles + 3 Jars- 90 Day Supply</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span> 
          <p>Cancel or Pause Anytime</p>
        </div>

      </div>
    `,
    ZFfp: `
      <div class="benefits-section" data-benefit-group="group-2">
        <div class="gift-row">
          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$29</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/26b598fd27c184b19a47901e31c980ba00c27cec.png?v=1776165273" alt="Gua Sha">
            </div>
            <p>Gua Sha</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$16</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/9b24d684728acf0dad50995d9a930f3957b42cf5.png?v=1776165273" alt="Body Brush">
            </div>
            <p>Body Brush</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$25</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/b0f8054fcb092f787a6eedb467f55e1dc15c1a13.png?v=1776165272" alt="Reset Protocol">
            </div>
            <p>Reset Protocol</p>
          </div>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>30 Day Money Back Guarantee</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>Free USA Shipping</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>Cancel or Pause Anytime</p>
        </div>
      </div>
    `,
    LK2z: `
      <div class="benefits-section" data-benefit-group="group-2">
        <div class="gift-row">
          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$29</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/26b598fd27c184b19a47901e31c980ba00c27cec.png?v=1776165273" alt="Gua Sha">
            </div>
            <p>Gua Sha</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$16</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/9b24d684728acf0dad50995d9a930f3957b42cf5.png?v=1776165273" alt="Body Brush">
            </div>
            <p>Body Brush</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$25</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/b0f8054fcb092f787a6eedb467f55e1dc15c1a13.png?v=1776165272" alt="Reset Protocol">
            </div>
            <p>Reset Protocol</p>
          </div>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>30 Day Money Back Guarantee</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>Free USA Shipping</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>Cancel or Pause Anytime</p>
        </div>
      </div>
    `,
    F8ng: `
      <div class="benefits-section" data-benefit-group="group-2">
        <div class="gift-row">
          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$29</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/26b598fd27c184b19a47901e31c980ba00c27cec.png?v=1776165273" alt="Gua Sha">
            </div>
            <p>Gua Sha</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$16</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/9b24d684728acf0dad50995d9a930f3957b42cf5.png?v=1776165273" alt="Body Brush">
            </div>
            <p>Body Brush</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$25</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/b0f8054fcb092f787a6eedb467f55e1dc15c1a13.png?v=1776165272" alt="Reset Protocol">
            </div>
            <p>Reset Protocol</p>
          </div>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>30 Day Money Back Guarantee</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>Free USA Shipping</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>Cancel or Pause Anytime</p>
        </div>
      </div>
    `,
    LNL7: `
      <div class="benefits-section" data-benefit-group="group-2">
        <div class="gift-row">
          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$29</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/26b598fd27c184b19a47901e31c980ba00c27cec.png?v=1776165273" alt="Gua Sha">
            </div>
            <p>Gua Sha</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$16</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/9b24d684728acf0dad50995d9a930f3957b42cf5.png?v=1776165273" alt="Body Brush">
            </div>
            <p>Body Brush</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$25</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/b0f8054fcb092f787a6eedb467f55e1dc15c1a13.png?v=1776165272" alt="Reset Protocol">
            </div>
            <p>Reset Protocol</p>
          </div>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>30 Day Money Back Guarantee</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>Free USA Shipping</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>Cancel or Pause Anytime</p>
        </div>
      </div>
    `,
    FHZi: `
      <div class="benefits-section" data-benefit-group="group-2">
        <div class="gift-row">
          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$29</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/26b598fd27c184b19a47901e31c980ba00c27cec.png?v=1776165273" alt="Gua Sha">
            </div>
            <p>Gua Sha</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$16</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/9b24d684728acf0dad50995d9a930f3957b42cf5.png?v=1776165273" alt="Body Brush">
            </div>
            <p>Body Brush</p>
          </div>

          <div class="gift-card">
            <div class="gift-badge">FREE <span class="slashed">$25</span></div>
            <div class="gift-img">
              <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/b0f8054fcb092f787a6eedb467f55e1dc15c1a13.png?v=1776165272" alt="Reset Protocol">
            </div>
            <p>Reset Protocol</p>
          </div>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>30 Day Money Back Guarantee</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>Free USA Shipping</p>
        </div>

        <div class="benefit-item">
          <span class="tick-icon-grn">
            <img src="https://cdn.shopify.com/s/files/1/0582/8804/6267/files/Vector_1_351c46b2-73bf-4cf3-80a8-ef076dcfc5d1.svg?v=1775077736"/>
          </span>
          <p>Cancel or Pause Anytime</p>
        </div>
      </div>
    `
  };

  bundleContent["1bf2a684-9626-4a76-964d-db632691955d"] = bundleContent.cN7v;
  bundleContent["9464728f-fc49-4e55-a767-589fe348ffac"] = bundleContent.cN7v;
  bundleContent["b672dad9-2785-4afd-afec-00f3bf63a85d"] = bundleContent.LK2z;
  bundleContent["9a313d1c-f06d-45b5-b340-6f0dd8c0a454"] = bundleContent.LK2z;



  function updateBenefits() {
    Object.entries(bundleContent).forEach(([dealId, html]) => {
      const selectedBar = document.querySelector(
        `.kaching-bundles__bar.kaching-bundles__bar--selected[data-deal-bar-id="${dealId}"] .kaching-bundles__bar-wrapper`
      );

      if (selectedBar && !selectedBar.querySelector('.benefits-section')) {
        selectedBar.insertAdjacentHTML('beforeend', html);
      }
    });

    document.querySelectorAll('.kaching-bundles__bar').forEach(bar => {
      const dealId = bar.dataset.dealBarId;
      const section = bar.querySelector('.benefits-section');

      if (!section) return;

      if (!bar.classList.contains('kaching-bundles__bar--selected')) {
        section.remove();
        return;
      }

      if (!bundleContent[dealId]) {
        section.remove();
      }
    });
  }

  updateBenefits();

  const observer = new MutationObserver(updateBenefits);
  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
});


// js code to change the copy of ATC buttons for kaching bundles

const bundleTextMap = {
  "1 MONTH FREE + GIFTS": ["cN7v", "onBI"],
  "10% OFF + GIFTS": ["ZFfp", "LK2z"]
};

function updateATCText(selectedInput) {
  const atcButton = document.querySelector('.product-form__submit span');
  if (!atcButton) return;

  const bundleId = selectedInput?.value;

  // Find matching label
  let newText = "Add To Cart";

  for (const [text, ids] of Object.entries(bundleTextMap)) {
    if (ids.includes(bundleId)) {
      newText = text;
      break;
    }
  }

  atcButton.textContent = newText;
}

// Handle change
document.addEventListener("change", function(e) {
  if (e.target.matches('.kaching-bundles__bar input[type="radio"]')) {
    updateATCText(e.target);
  }
});

// Run on DOM ready
document.addEventListener("DOMContentLoaded", function () {
  const selected = document.querySelector('.kaching-bundles__bar input[type="radio"]:checked');
  if (selected) {
    updateATCText(selected);
  }
});

// Handle late-loading bundle app
window.addEventListener("load", function () {
  setTimeout(() => {
    const selected = document.querySelector('.kaching-bundles__bar input[type="radio"]:checked');
    if (selected) {
      updateATCText(selected);
    }
  }, 300);
});